import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-no-access-panel',
    templateUrl: './no-access-panel.component.html',
    styleUrls: ['./no-access-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NoAccessPanelComponent {
  @Input() public messageKey: string = 'INTL_COMMUNICATION_ACCESS_BLOCKED_MESSAGE';
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;
}
